import MonacoEditor from "@monaco-editor/react";
import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { apiServices } from '../../utils/apiServices';
import { useAppContext } from '../../context/AppContext';
import { useTheme } from '../../context/ThemeContext';

const TraderCustomScriptTab = ({refreshFunc}: {refreshFunc: () => void}) => {
  const { activeAccount, setIsLoading } = useAppContext();
  const { theme } = useTheme();
  const [isRunningScript, setIsRunningScript] = useState(false);
  const [code, setCode] = useState(`/* 
Available functions:
stake(subnetId: number, stakeAmount: number): Promise<void>
unstake(subnetId: number, unstakeAmount: number): Promise<void>
getSubnetPrice(subnetId: number): Promise<number>
*/

// Sample Script code
const subnetId = 23;
const stakeAmount = 10;
const stakePrice = 0.0025;
const unstakePrice = 0.003;
let staked = false;
let repeat_cnt = 0;
while (true) {
    const isScriptRunning = localStorage.getItem('customScriptRunning') === 'true';
    if (!isScriptRunning) {
      break;
    }

    const sn_price = await getSubnetPrice(subnetId);

    if (!staked && sn_price <= stakePrice) {
        await stake(subnetId, stakeAmount);
        staked = true;
    } else if (staked && sn_price > unstakePrice) {
        await unstake(subnetId, stakeAmount / 2);
        staked = false;
        repeat_cnt++;
    }
    if (repeat_cnt >= 3) {
        break;
    }
    await new Promise(res => setTimeout(res, 12000)); // Wait for a new block
}
    `);

  // const customStakeFunc = async (sn_id: Number, stakeAmount: Number) => {
  //   try {
  //     if (!activeAccount?.address) {
  //       toast.error('Trader ID is not defined');
        
  //       return;
  //     }
  //     setIsLoading(true);
  //     const signature = localStorage.getItem(activeAccount?.address || '');
  //     if (!signature) {
  //       toast.error('Signature is not defined');
  //       return;
  //     }
  //     apiServices.stakes.add(
  //       activeAccount?.address || '',
  //       Number(sn_id),
  //       Number(stakeAmount),
  //       signature
  //     ).then((res: any) => {
  //       if (res.trader_id) {
  //         toast.success('Staked successfully!');
  //         refreshFunc(); // Refresh trader data
  //       } else {
  //         console.log(`Failed to stake:`, res);
  //         toast.error(`Failed to stake: Please try again.`);
  //       }
  //     }).catch((error: Error) => {
  //       console.log(`Failed to stake:`, error);
  //       toast.error(`Failed to stake: Please try again.`);
  //     }).finally(() => {
  //       setIsLoading(false);
  //     });
  //   } catch (err: any) {
  //     toast.error(`Custom script error: ${err.message || err}`);
  //   }
  // }

  // const customUnstakeFunc = (sn_id: Number, unstakeAmount?: Number) => {
  //   try {
  //     console.log(`Custom unstaking function called with subnetId: ${sn_id}, unstakeAmount: ${unstakeAmount}`);
  //   } catch (err: any) {
  //     toast.error(`Custom script error: ${err.message || err}`);
  //   }
  // }

  // const getSubnetPrice = async (sn_id: Number) => {
  //   return await apiServices.stakes.getSubnetPrice(Number(sn_id));
  // }

  const runCustomScript = () => {
    toast.info("Custom script function will be available from the next version.");
    // try {
    //   if (isRunningScript) {
    //     setIsRunningScript(false);
    //     localStorage.setItem('customScriptRunning', 'false');
    //     toast.info("Script stopped.");
    //   } else {
    //     setIsRunningScript(true);
    //     localStorage.setItem('customScriptRunning', 'true');
    //     const fn = new Function('stake', 'unstake', 'getSubnetPrice', `
    //       return (async () => {
    //         ${code}
    //       })();
    //     `);
    //     fn(customStakeFunc, customUnstakeFunc, getSubnetPrice);
    //     toast.success("Script started.");
    //   }
    // } catch (err: any) {
    //   toast.error(`Script error: ${err.message || err}`);
    // }
  }

  useEffect(() => {
    localStorage.setItem('customScriptRunning', 'false');
  }, []);

  return (
    <div className="space-y-4">
      <div className="">
        <MonacoEditor
          height="500px"
          width="100%"
          language="javascript"
          value={code}
          onChange={(value) => setCode(value || "")}
          theme={theme === 'dark' ? 'vs-dark' : 'vs'}
          options={{
            fontSize: 14,
            minimap: { enabled: false },
            fontFamily: 'monospace',
            wordWrap: 'on',
            scrollBeyondLastLine: false,
            automaticLayout: true,
          }}
          beforeMount={(monaco) => {
            // Disable web workers to avoid CDN loading issues
            monaco.editor.defineTheme('vs-dark', {
              base: 'vs-dark',
              inherit: true,
              rules: [],
              colors: {}
            });
          }}
        />
      </div>
      <div className="flex justify-end gap-4">
        <button
          onClick={runCustomScript}
          className={`py-2 ${isRunningScript ? 'bg-[#EE3333]' : 'bg-[#00FFEE]'} text-white dark:text-black rounded-[100px] hover:opacity-80 transition-all duration-200 text-[14px] h-[46px] px-[42px] disabled:opacity-50 disabled:cursor-not-allowed`}
        >
          {isRunningScript ? "Stop Script" : "Start Script"}
        </button>
      </div>
    </div>
  )
}

export default TraderCustomScriptTab;